<template>
  <v-container class="office-container">
    <v-tabs v-model="mainTab" bg-color="grey-darken-3" class="mb-3">
      <v-tab value="refurbish"><v-icon start>mdi-tools</v-icon>Frankreich</v-tab>
      <v-tab value="dtc"><v-icon start>mdi-package-variant-closed</v-icon>DTC</v-tab>
      <v-tab value="schrott_bware"><v-icon start>mdi-delete-variant</v-icon>Schrott B-Ware</v-tab>
    </v-tabs>

    <DtcOfficePanel v-if="mainTab === 'dtc'" />
    <BWareSchrottOfficePanel v-if="mainTab === 'schrott_bware'" />

    <div v-show="mainTab === 'refurbish'">
    <!-- Paletten Übersicht -->
    <v-card v-if="!selectedPalette" class="status-overview-card mb-6">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" size="24" class="mr-2">mdi-briefcase-check</v-icon>
        Frankreich Freigabe
        <v-spacer></v-spacer>
        <v-btn
          icon
          class="mx-1"
          variant="text"
          @click="dialogs.artikelKatalog = true"
          color="success"
          v-tooltip="'Artikel-Katalog verwalten'"
        >
          <v-icon>mdi-database-edit</v-icon>
        </v-btn>
        <v-chip color="success" size="small">{{ paletten.length }} Paletten</v-chip>
      </v-card-title>

      <v-divider class="card-divider"></v-divider>

      <!-- Tabs: Aktiv / An Versand / Archiv -->
      <v-tabs v-model="viewTab" bg-color="grey-darken-4">
        <v-tab value="aktiv">
          <v-icon start>mdi-clock-outline</v-icon>
          Aktive Paletten
        </v-tab>
        <v-tab value="versand">
          <v-icon start>mdi-truck-delivery</v-icon>
          An Versand
        </v-tab>
        <v-tab value="archiv">
          <v-icon start>mdi-archive</v-icon>
          Archiv
        </v-tab>
        <v-tab value="geraete">
          <v-icon start>mdi-magnify</v-icon>
          Geräte finden
        </v-tab>
      </v-tabs>

      <v-card-text class="py-4">
        <!-- Paletten-Suchfeld (aktiv/archiv) -->
        <v-text-field
          v-if="viewTab !== 'geraete'"
          v-model="palettenSuche"
          label="Paletten suchen"
          variant="outlined"
          bg-color="rgba(30, 30, 40, 0.5)"
          hide-details="auto"
          clearable
          class="form-field mb-4"
          color="success"
          hint="Suche nach Paletten-Nr, Lieferschein oder Bestellnummer"
        >
          <template v-slot:prepend-inner>
            <v-icon color="success" size="small">mdi-magnify</v-icon>
          </template>
        </v-text-field>

        <!-- Geräte-Suchformular -->
        <div v-if="viewTab === 'geraete'" class="mb-6">
          <v-row class="mb-4">
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="geraeteSuchTyp"
                label="Suchtyp"
                :items="geraeteSuchTypOptions"
                variant="outlined"
                bg-color="rgba(30, 30, 40, 0.5)"
                color="success"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="8">
              <v-text-field
                v-model="geraeteSuchBegriff"
                :label=" geraeteSuchTyp === 'ean' ? 'EAN eingeben' : geraeteSuchTyp === 'model' ? 'Modell eingeben' : geraeteSuchTyp === 'cmmf' ? 'CMMF eingeben' : 'Commercial Code eingeben'"
                variant="outlined"
                bg-color="rgba(30, 30, 40, 0.5)"
                hide-details="auto"
                clearable
                color="success"
                @keyup.enter="sucheGeraete"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="success" size="small">mdi-magnify</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="success"
                variant="flat"
                @click="sucheGeraete"
                :loading="loading.geraeteSuche"
                prepend-icon="mdi-magnify"
              >
                Suchen
              </v-btn>
              <v-btn
                variant="text"
                @click="zuruecksetzenGeraeteSuche"
                class="ml-2"
              >
                Zurücksetzen
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- Geräte-Suchergebnisse Tabelle -->
        <v-data-table
          v-if="viewTab === 'geraete'"
          :headers="geraeteSuchHeaders"
          :items="geraeteSuchErgebnisse"
          :loading="loading.geraeteSuche"
          item-value="id"
          class="elevation-0"
          :no-data-text="geraeteSuchErgebnisse.length === 0 && !loading.geraeteSuche ? 'Keine Geräte gefunden - nutze das Suchformular oben' : 'Wird geladen...'"
        >
          <template v-slot:[`item.palette_status`]="{ item }">
            <v-chip
              v-if="item.palette_status === 'office_freigabe'"
              size="small"
              color="indigo"
              variant="flat"
            >
              <v-icon start size="small">mdi-clipboard-check</v-icon>
              Zur Prüfung
            </v-chip>
            <v-chip
              v-else-if="item.palette_status === 'versand_final'"
              size="small"
              color="blue-darken-1"
              variant="flat"
            >
              <v-icon start size="small">mdi-truck-delivery</v-icon>
              An Versand
            </v-chip>
            <span v-else class="text-grey">{{ item.palette_status }}</span>
          </template>
          <template v-slot:[`item.paletten_nr`]="{ item }">
            <strong class="text-indigo-darken-1">{{ item.paletten_nr }}</strong>
          </template>
          <template v-slot:[`item.actions_device`]="{ item }">
            <v-btn
              icon="mdi-pencil"
              size="small"
              variant="text"
              color="indigo"
              @click="loadPalette(item.palette_id)"
              title="Palette bearbeiten"
            ></v-btn>
          </template>
        </v-data-table>

            <v-data-table
              v-if="viewTab !== 'geraete'"
              :headers="palettenHeaders"
              :items="gefiltertePaletten"
              :loading="loading.paletten"
              item-value="id"
              class="elevation-0"
            >
              <template v-slot:[`item.status`]="{ item }">
                <v-chip
                  v-if="item.status === 'erfassung' && item.bearbeitet_von_office_user_id"
                  size="small"
                  color="warning"
                  variant="flat"
                >
                  <v-icon start size="small">mdi-clock-alert</v-icon>
                  Nachbearbeitung
                </v-chip>
                <v-chip
                  v-else-if="item.status === 'erfassung'"
                  size="small"
                  color="grey-lighten-1"
                  variant="flat"
                >
                  <v-icon start size="small">mdi-package-variant-closed</v-icon>
                  Wird erstellt
                </v-chip>
                <v-chip
                  v-else-if="item.status === 'office_freigabe'"
                  size="small"
                  color="indigo"
                  variant="flat"
                >
                  <v-icon start size="small">mdi-clipboard-check</v-icon>
                  Zur Prüfung
                </v-chip>
                <v-chip
                  v-else-if="item.status === 'versand_final'"
                  size="small"
                  color="blue-darken-1"
                  variant="flat"
                >
                  <v-icon start size="small">mdi-truck-delivery</v-icon>
                  An Versand
                </v-chip>
              </template>
              <template v-slot:[`item.paletten_nr`]="{ item }">
                <strong :class="item.status === 'erfassung' || item.status === 'versand_final' ? 'text-grey' : 'text-indigo-darken-1'">{{ item.paletten_nr }}</strong>
              </template>
              <template v-slot:[`item.lieferschein`]="{ item }">
                <span v-if="item.lieferschein" class="text-medium-emphasis">{{ item.lieferschein }}</span>
                <span v-else class="text-grey">—</span>
              </template>
              <template v-slot:[`item.anzahl_positionen`]="{ item }">
                <v-chip size="small" color="info">{{ item.anzahl_positionen }} Artikel</v-chip>
              </template>
              <template v-slot:[`item.gesamtstueckzahl`]="{ item }">
                <v-chip size="small" color="success">{{ item.gesamtstueckzahl }} Stück</v-chip>
              </template>
              <template v-slot:[`item.gesamtgewicht`]="{ item }">
                {{ parseFloat(item.gesamtgewicht) ? parseFloat(item.gesamtgewicht).toFixed(2) + ' kg' : '—' }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip v-if="item.status === 'erfassung' && item.bearbeitet_von_office_user_id" text="Palette wird von Refurbish nachbearbeitet">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon="mdi-lock"
                      size="small"
                      variant="text"
                      color="grey"
                      disabled
                    ></v-btn>
                  </template>
                </v-tooltip>
                <v-tooltip v-else-if="item.status === 'erfassung'" text="Palette wird gerade von Refurbish erstellt">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon="mdi-clock-outline"
                      size="small"
                      variant="text"
                      color="grey"
                      disabled
                    ></v-btn>
                  </template>
                </v-tooltip>
                <v-tooltip v-else-if="item.status === 'versand_final'" text="Palette an Versand - Details anzeigen">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="blue"
                      @click="loadPalette(item.id)"
                    ></v-btn>
                  </template>
                </v-tooltip>
                <v-btn
                  v-else
                  icon="mdi-clipboard-edit"
                  size="small"
                  variant="text"
                  color="indigo"
                  @click="loadPalette(item.id)"
                  title="Palette bearbeiten"
                ></v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <!-- Palette ausgewählt: Detailansicht -->
        <div v-if="selectedPalette">
          <v-btn
            class="mb-4"
            prepend-icon="mdi-arrow-left"
            @click="backToList"
          >
            Zurück zur Übersicht
          </v-btn>

          <v-row>
            <!-- MASKE 1: SAP-Bearbeitung (Links) -->
            <v-col cols="12" md="6">
              <v-card class="sap-card mb-4">
                <v-card-title class="bg-indigo-darken-1">
                  <v-icon class="mr-2">mdi-clipboard-list</v-icon>
                  SAP Bearbeitung
                  <v-spacer></v-spacer>
                  <v-chip size="small" color="white" variant="outlined">
                    {{ selectedPalette.paletten_nr }}
                  </v-chip>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <!-- CMMF Kopieren Button -->
                  <v-btn
                    block
                    color="primary"
                    variant="tonal"
                    class="mb-2"
                    prepend-icon="mdi-content-copy"
                    @click="copyCMMFToClipboard"
                  >
                    Alle CMMF in Zwischenablage kopieren
                  </v-btn>

                  <!-- Anzahl Kopieren Button -->
                  <v-btn
                    block
                    color="indigo"
                    variant="tonal"
                    class="mb-4"
                    prepend-icon="mdi-numeric"
                    @click="copyAnzahlToClipboard"
                  >
                    Alle Mengen in Zwischenablage kopieren
                  </v-btn>

                  <!-- Artikel-Liste für SAP -->
                  <v-table density="comfortable" class="sap-table">
                    <thead>
                      <tr>
                        <th>CMMF</th>
                        <th>Artikel</th>
                        <th class="text-center">Menge</th>
                        <th class="text-center">Gewicht</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="pos in positionen" :key="pos.id">
                        <td><code>{{ pos.code_cmmf || '—' }}</code></td>
                        <td>
                          <div class="text-body-2">{{ pos.description_cmmf || pos.gtin_ean }}</div>
                          <div class="text-caption text-grey">EAN: {{ pos.gtin_ean }} | SKU: {{ pos.code_commercial || '—'}}</div>
                        </td>
                        <td class="text-center">
                          <v-chip size="small" color="primary">{{ pos.menge }}x</v-chip>
                        </td>
                        <td class="text-center">
                          <div v-if="parseFloat(pos.gewicht_kg)" class="text-body-2">
                            {{ parseFloat(pos.gewicht_kg).toFixed(3) }} kg
                            <div class="text-caption text-success">
                              ({{ (parseFloat(pos.gewicht_kg) * pos.menge).toFixed(2) }} kg)
                            </div>
                          </div>
                          <div v-else>
                            <v-btn
                              size="x-small"
                              color="warning"
                              variant="outlined"
                              @click="gewichtNachtragen(pos)"
                            >
                              <v-icon start size="small">mdi-pencil</v-icon>
                              Gewicht nachtragen
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>

                  <v-divider class="my-4"></v-divider>

                  <!-- Gesamtgewicht Anzeige (automatisch berechnet) -->
                  <v-alert type="info" variant="tonal" density="compact" class="mb-4">
                    <strong>{{ positionen.length }} Artikel</strong> ·
                    <strong>{{ gesamtStueckzahl }} Stück</strong> gesamt
                  </v-alert>
                  <v-alert type="info" variant="tonal" density="compact">
                    <v-row align="center">
                      <v-col cols="auto">
                        <v-icon>mdi-weight-kilogram</v-icon>
                      </v-col>
                      <v-col>
                        <strong>Gesamtgewicht:</strong>
                        {{ hatGewichtsdaten ? gesamtGewichtBerechnet.toFixed(2) + ' kg' : 'Keine Gewichtsdaten' }}
                      </v-col>
                    </v-row>
                  </v-alert>
                  <div class="text-caption text-grey mt-2">
                    Wird automatisch aus Artikel-Katalog berechnet (Menge × Einzelgewicht)
                  </div>

                  <!-- Refurbish Notizen (readonly) -->
                  <v-textarea
                    v-if="selectedPalette.refurbish_notiz"
                    :model-value="selectedPalette.refurbish_notiz"
                    label="Notizen von Refurbish"
                    variant="outlined"
                    bg-color="rgba(30, 30, 40, 0.5)"
                    hide-details="auto"
                    rows="2"
                    class="form-field mt-4"
                    color="orange"
                    readonly
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="orange" size="small">mdi-information-outline</v-icon>
                    </template>
                  </v-textarea>

                  <!-- Office Notizen -->
                  <v-textarea
                    v-model="selectedPalette.office_notiz"
                    label="Office Notizen"
                    variant="outlined"
                    bg-color="rgba(30, 30, 40, 0.5)"
                    hide-details="auto"
                    rows="3"
                    class="form-field mt-4"
                    color="success"
                    :disabled="selectedPalette.status === 'versand_final'"
                    @blur="saveNote('office_notiz')"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="success" size="small">mdi-note-text</v-icon>
                    </template>
                  </v-textarea>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- MASKE 2: Lieferschein (Rechts) -->
            <v-col cols="12" md="6">
              <v-card class="lieferschein-card mb-4">
                <v-card-title class="bg-success-darken-1">
                  <v-icon class="mr-2">mdi-file-document</v-icon>
                  Lieferschein
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-form @submit.prevent="saveLieferschein">
                    <!-- Belegdatum -->
                    <v-text-field
                      v-model="selectedPalette.belegdatum"
                      label="Belegdatum"
                      type="date"
                      variant="outlined"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      color="success"
                      :disabled="selectedPalette.status === 'versand_final'"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>

                    <!-- Lieferschein-Nr -->
                    <v-text-field
                      v-model="selectedPalette.lieferschein"
                      label="Lieferschein-Nummer"
                      variant="outlined"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      color="success"
                      :disabled="selectedPalette.status === 'versand_final'"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small">mdi-file-document-outline</v-icon>
                      </template>
                    </v-text-field>

                    <!-- Bestellnummer -->
                    <v-text-field
                      v-model="selectedPalette.bestellnummer"
                      label="Bestellnummer"
                      variant="outlined"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      color="success"
                      :disabled="selectedPalette.status === 'versand_final'"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small">mdi-cart</v-icon>
                      </template>
                    </v-text-field>

                    <v-divider class="my-4"></v-divider>

                    <!-- Lieferschein-Übersicht -->
                    <v-card variant="outlined" class="lieferschein-preview">
                      <v-card-title class="text-subtitle-1 bg-grey-lighten-4">
                        Lieferschein-Vorschau
                      </v-card-title>
                      <v-card-text class="pa-3">
                        <v-simple-table density="compact">
                          <tbody>
                            <tr>
                              <td class="text-grey">Paletten-Nr:</td>
                              <td><strong>{{ selectedPalette.paletten_nr }}</strong></td>
                            </tr>
                            <tr>
                              <td class="text-grey">Belegdatum:</td>
                              <td>{{ selectedPalette.belegdatum || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="text-grey">Lieferschein:</td>
                              <td>{{ selectedPalette.lieferschein || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="text-grey">Bestellnummer:</td>
                              <td>{{ selectedPalette.bestellnummer || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="text-grey">Gesamtgewicht:</td>
                              <td>{{ hatGewichtsdaten ? gesamtGewichtBerechnet.toFixed(2) + ' kg' : '—' }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>

                        <v-divider class="my-3"></v-divider>

                        <!-- Artikel-Tabelle -->
                        <div class="text-caption text-grey mb-2">Artikel auf Lieferschein:</div>
                        <v-simple-table density="compact" class="artikel-tabelle">
                          <thead>
                            <tr>
                              <th>CMMF</th>
                              <th>Artikel</th>
                              <th class="text-center">Menge</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="pos in positionen" :key="pos.id" class="text-caption">
                              <td><code>{{ pos.code_cmmf }}</code></td>
                              <td>
                                <div>{{ pos.description_cmmf || pos.gtin_ean }}</div>
                                <div class="text-grey">EAN: {{ pos.gtin_ean }} | SKU: {{ pos.code_commercial || '—' }}</div>
                              </td>
                              <td class="text-center">{{ pos.menge }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>

                    <v-btn
                      type="submit"
                      block
                      color="success"
                      size="large"
                      class="mt-4"
                      prepend-icon="mdi-content-save"
                      :loading="loading.saving"
                      :disabled="selectedPalette.status === 'versand_final'"
                    >
                      Lieferschein speichern
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>

              <!-- Aktionen -->
              <v-card>
                <v-card-text>
                  <v-btn
                    v-if="selectedPalette.status !== 'versand_final'"
                    block
                    color="indigo-darken-1"
                    size="large"
                    prepend-icon="mdi-arrow-right"
                    @click="freigabeAnVersand"
                    :disabled="!selectedPalette.lieferschein || !selectedPalette.belegdatum"
                  >
                    An Versand freigeben
                  </v-btn>
                  <v-alert v-else type="info" variant="tonal" density="compact" class="mb-2">
                    <v-icon start>mdi-truck-delivery</v-icon>
                    Palette ist im Versand (nur lesbar)
                  </v-alert>
                  <v-btn
                    block
                    color="warning"
                    size="large"
                    variant="outlined"
                    prepend-icon="mdi-arrow-left"
                    :class="selectedPalette.status === 'versand_final' ? '' : 'mt-2'"
                    @click="zurueckAnRefurbish"
                  >
                    Zurück an Frankreich
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

    <!-- Dialog: Gewicht nachtragen -->
    <v-dialog v-model="dialogs.gewichtNachtragen" max-width="500">
      <v-card>
        <v-card-title class="bg-warning text-white">
          <v-icon class="mr-2">mdi-weight-kilogram</v-icon>
          Gewicht nachtragen
        </v-card-title>
        <v-card-text v-if="gewichtNachtragArtikel" class="pt-4">
          <v-alert type="info" variant="tonal" density="compact" class="mb-4">
            <div class="text-body-2"><strong>{{ gewichtNachtragArtikel.description_cmmf }}</strong></div>
            <div class="text-caption">EAN: {{ gewichtNachtragArtikel.gtin_ean }}</div>
          </v-alert>

          <v-text-field
            v-model.number="neuesGewicht"
            label="Gewicht in kg"
            type="number"
            step="0.001"
            min="0"
            variant="outlined"
            prepend-inner-icon="mdi-weight-kilogram"
            suffix="kg"
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="dialogs.gewichtNachtragen = false">Abbrechen</v-btn>
          <v-btn color="success" variant="elevated" @click="gewichtSpeichern">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Artikel-Katalog -->
    <v-dialog v-model="dialogs.artikelKatalog" max-width="1200" scrollable>
      <v-card>
        <v-card-title class="bg-primary text-white d-flex align-center">
          <v-icon class="mr-2">mdi-database-edit</v-icon>
          Artikel-Katalog Verwaltung
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            color="white"
            @click="dialogs.artikelKatalog = false"
          ></v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <!-- Suchfeld -->
          <v-text-field
            v-model="artikelSuche"
            label="Artikel suchen"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="compact"
            clearable
            class="mb-4"
            hint="Suche nach EAN, Code CMMF, Beschreibung oder Paletten-Nr"
          ></v-text-field>

          <div class="d-flex gap-2 mb-4">
            <v-btn
              color="primary"
              variant="elevated"
              @click="fetchArtikelKatalog"
              :loading="loading.katalog"
            >
              <v-icon start>mdi-refresh</v-icon>
              Katalog laden
            </v-btn>
            <v-btn
              color="success"
              variant="elevated"
              @click="neuerArtikelDialog"
            >
              <v-icon start>mdi-plus</v-icon>
              Neuer Artikel
            </v-btn>
          </div>

          <!-- Artikel-Tabelle -->
          <v-data-table
            :headers="[
              { title: 'Code CMMF', key: 'code_cmmf', sortable: true },
              { title: 'Beschreibung', key: 'description_cmmf', sortable: true },
              { title: 'EAN', key: 'gtin_ean', sortable: true },
              { title: 'Palette', key: 'paletten_nr', sortable: true },
              { title: 'Gewicht (kg)', key: 'gewicht_kg', sortable: true },
              { title: 'Aktionen', key: 'actions', sortable: false }
            ]"
            :items="gefilterteArtikelKatalog"
            :loading="loading.katalog"
            item-value="id"
            density="compact"
            class="elevation-1"
            :items-per-page="10"
          >
            <template v-slot:[`item.gewicht_kg`]="{ item }">
              <v-text-field
                v-model.number="item.gewicht_kg"
                type="number"
                step="0.001"
                density="compact"
                variant="outlined"
                hide-details
                style="max-width: 120px;"
                suffix="kg"
              ></v-text-field>
            </template>
            <template v-slot:[`item.paletten_nr`]="{ item }">
              <v-chip size="small" color="primary" v-if="item.paletten_nr">
                {{ item.paletten_nr }}
              </v-chip>
              <span v-else class="text-grey">—</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                size="small"
                color="success"
                variant="text"
                @click="updateArtikelGewicht(item)"
              >
                <v-icon size="small">mdi-content-save</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog: Neuer Artikel -->
    <v-dialog v-model="dialogs.neuerArtikel" max-width="800" scrollable>
      <v-card class="dialog-card">
        <v-card-title class="bg-success text-white d-flex align-center">
          <v-icon class="mr-2">mdi-plus-circle</v-icon>
          Neuen Artikel anlegen
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            color="white"
            @click="dialogs.neuerArtikel = false"
          ></v-btn>
        </v-card-title>
        <v-divider class="card-divider"></v-divider>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="neuerArtikel.gtin_ean"
                label="EAN / GTIN *"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-barcode"
                hint="Pflichtfeld"
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="neuerArtikel.code_cmmf"
                label="Code CMMF *"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                hint="Pflichtfeld"
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="neuerArtikel.description_cmmf"
                label="Beschreibung"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-text"
                rows="2"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="neuerArtikel.code_commercial"
                label="Code Commercial"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-shopping"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="neuerArtikel.famille_n"
                label="Famille N"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-family-tree"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="neuerArtikel.family_lev1_description"
                label="Family Level 1 Description"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-format-list-text"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="neuerArtikel.eligible"
                label="Eligible"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-check-circle"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="neuerArtikel.gewicht_kg"
                label="Gewicht (kg)"
                type="number"
                step="0.001"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-weight-kilogram"
                suffix="kg"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="neuerArtikel.paletten_nr"
                label="Paletten-Nr"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-package-variant"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="dialogs.neuerArtikel = false">Abbrechen</v-btn>
          <v-btn
            color="success"
            variant="elevated"
            @click="artikelSpeichern"
            :loading="loading.saving"
          >
            <v-icon start>mdi-content-save</v-icon>
            Artikel erstellen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useToast } from 'vue-toastification';
import axios from 'axios';
import { API_BASE_URL } from '@/config';
import DtcOfficePanel from '@/components/Dtc/DtcOfficePanel.vue';
import BWareSchrottOfficePanel from '@/components/BWare/BWareSchrottOfficePanel.vue';

const authStore = useAuthStore();
const toast = useToast();
const mainTab = ref('refurbish');

const paletten = ref([]);
const selectedPalette = ref(null);
const originalPaletteData = ref(null); // Für Änderungserkennung
const positionen = ref([]);
const palettenSuche = ref('');
const viewTab = ref('aktiv'); // 'aktiv' | 'versand' | 'archiv' | 'geraete'
const artikelKatalog = ref([]);
const artikelSuche = ref('');

const loading = ref({
  paletten: false,
  saving: false,
  katalog: false,
  geraeteSuche: false
});

const dialogs = ref({
  artikelKatalog: false,
  gewichtNachtragen: false,
  neuerArtikel: false
});

const gewichtNachtragArtikel = ref(null);
const neuesGewicht = ref(null);

const neuerArtikel = ref({
  gtin_ean: '',
  code_cmmf: '',
  description_cmmf: '',
  code_commercial: '',
  famille_n: '',
  family_lev1_description: '',
  eligible: '',
  gewicht_kg: null,
  paletten_nr: ''
});

// Gerätesuche Variablen
const geraeteSuchTyp = ref('ean');
const geraeteSuchBegriff = ref('');
const geraeteSuchErgebnisse = ref([]);
const geraeteSuchTypOptions = [
  { title: 'EAN', value: 'ean' },
  { title: 'Modell', value: 'model' },
  { title: 'CMMF', value: 'cmmf' },
  { title: 'Commercial Code', value: 'commercial' }
];

const palettenHeaders = [
  { title: 'Status', key: 'status', sortable: true },
  { title: 'Paletten-Nr.', key: 'paletten_nr', sortable: true },
  { title: 'Arbeits-Nr.', key: 'arbeits_paletten_nr', sortable: true },
  { title: 'Lieferschein', key: 'lieferschein', sortable: true },
  { title: 'Erstellt am', key: 'erfassung_datum', sortable: true },
  { title: 'Artikel', key: 'anzahl_positionen', sortable: false },
  { title: 'Stückzahl', key: 'gesamtstueckzahl', sortable: false },
  { title: 'Gewicht', key: 'gesamtgewicht', sortable: true },
  { title: 'Aktionen', key: 'actions', sortable: false }
];

const geraeteSuchHeaders = [
  { title: 'Palette', key: 'paletten_nr', sortable: true },
  { title: 'Palette Status', key: 'palette_status', sortable: true },
  { title: 'CMMF', key: 'code_cmmf', sortable: true },
  { title: 'Commercial Code', key: 'code_commercial', sortable: true },
  { title: 'Beschreibung', key: 'description_cmmf', sortable: true },
  { title: 'EAN', key: 'gtin_ean', sortable: true },
  { title: 'Menge', key: 'menge', sortable: false },
  { title: 'Aktionen', key: 'actions_device', sortable: false }
];

const gesamtStueckzahl = computed(() => {
  return positionen.value.reduce((sum, pos) => sum + (parseInt(pos.menge) || 0), 0);
});

const gesamtGewichtBerechnet = computed(() => {
  return positionen.value.reduce((sum, pos) => {
    const menge = Number(pos.menge) || 0;
    const gewicht = Number(pos.gewicht_kg);

    if (!Number.isFinite(gewicht) || gewicht <= 0 || menge <= 0) {
      return sum;
    }

    return sum + (menge * gewicht);
  }, 0);
});

const hatGewichtsdaten = computed(() => {
  return positionen.value.some(pos => Number.isFinite(Number(pos.gewicht_kg)) && Number(pos.gewicht_kg) > 0);
});

const gefiltertePaletten = computed(() => {
  let filtered = paletten.value;

  // Tab-Filter: Aktiv / An Versand / Archiv
  if (viewTab.value === 'aktiv') {
    // Aktive Paletten: erfassung (mit Nachbearbeitung), office_freigabe
    filtered = filtered.filter(p =>
      (p.status === 'erfassung' && p.bearbeitet_von_office_user_id) ||
      p.status === 'office_freigabe'
    );
  } else if (viewTab.value === 'versand') {
    filtered = filtered.filter(p => p.status === 'versand_final');
  } else if (viewTab.value === 'archiv') {
    filtered = filtered.filter(p => p.status === 'abgeschlossen');
  } else {
    filtered = [];
  }

  // Suchfilter
  if (!palettenSuche.value) return filtered;

  const suche = palettenSuche.value.toLowerCase();
  return filtered.filter(p =>
    p.paletten_nr?.toLowerCase().includes(suche) ||
    p.lieferschein?.toLowerCase().includes(suche) ||
    p.bestellnummer?.toLowerCase().includes(suche)
  );
});

const gefilterteArtikelKatalog = computed(() => {
  if (!artikelSuche.value) return artikelKatalog.value;

  const suche = artikelSuche.value.toLowerCase();
  return artikelKatalog.value.filter(a =>
    a.gtin_ean?.toLowerCase().includes(suche) ||
    a.code_cmmf?.toLowerCase().includes(suche) ||
    a.description_cmmf?.toLowerCase().includes(suche) ||
    a.paletten_nr?.toLowerCase().includes(suche)
  );
});

const fetchPaletten = async () => {
  loading.value.paletten = true;
  try {
    const response = await axios.get(`${API_BASE_URL}refurbish/index.php`, {
      params: { action: 'get_paletten' },
      withCredentials: true
    });

    if (response.data.status === 'success') {
      // Alle Paletten laden, Filterung erfolgt in gefiltertePaletten computed
      paletten.value = response.data.paletten;
    } else {
      toast.error(response.data.message || 'Fehler beim Laden der Paletten');
    }
  } catch (error) {
    console.error('Fehler beim Laden der Paletten:', error);
    toast.error('Netzwerkfehler');
  } finally {
    loading.value.paletten = false;
  }
};

const loadPalette = async (paletteId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}refurbish/index.php`, {
      params: { action: 'get_palette', palette_id: paletteId },
      withCredentials: true
    });

    if (response.data.status === 'success') {
      selectedPalette.value = response.data.palette;
      positionen.value = response.data.palette.positionen || [];

      // Original-Werte für Änderungserkennung speichern
      originalPaletteData.value = {
        belegdatum: response.data.palette.belegdatum,
        lieferschein: response.data.palette.lieferschein,
        bestellnummer: response.data.palette.bestellnummer
      };
    } else {
      toast.error(response.data.message || 'Fehler beim Laden der Palette');
    }
  } catch (error) {
    console.error('Fehler beim Laden der Palette:', error);
    toast.error('Netzwerkfehler');
  }
};

const backToList = () => {
  selectedPalette.value = null;
  originalPaletteData.value = null;
  positionen.value = [];
  fetchPaletten();
};

// ========================================
// METHODEN - Gerätesuche
// ========================================

const sucheGeraete = async () => {
  if (!geraeteSuchBegriff.value) {
    toast.warning('Bitte einen Suchbegriff eingeben');
    return;
  }

  loading.value.geraeteSuche = true;
  try {
    // Rufe Backend auf um Positionen in den relevanten Status zu suchen
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'search_devices_by_status',
        search_type: geraeteSuchTyp.value,
        search_query: geraeteSuchBegriff.value,
        statuses: ['office_freigabe', 'versand_final']
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      geraeteSuchErgebnisse.value = response.data.positionen || [];

      if (geraeteSuchErgebnisse.value.length === 0) {
        toast.info('Keine Geräte gefunden');
      } else {
        toast.success(`${geraeteSuchErgebnisse.value.length} Gerät${geraeteSuchErgebnisse.value.length !== 1 ? 'e' : ''} gefunden`);
      }
    } else {
      toast.error(response.data.message || 'Fehler bei der Suche');
    }
  } catch (error) {
    console.error('Fehler bei der Suche:', error);
    toast.error('Netzwerkfehler bei der Suche');
  } finally {
    loading.value.geraeteSuche = false;
  }
};

const zuruecksetzenGeraeteSuche = () => {
  geraeteSuchBegriff.value = '';
  geraeteSuchErgebnisse.value = [];
  geraeteSuchTyp.value = 'ean';
};

const saveNote = async (noteField) => {
  try {
    await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'add_note',
        palette_id: selectedPalette.value.id,
        note_field: noteField,
        notiz: selectedPalette.value[noteField]
      },
      { withCredentials: true }
    );
    toast.success('Notiz gespeichert');
  } catch (error) {
    console.error('Fehler beim Speichern der Notiz:', error);
  }
};

const copyCMMFToClipboard = async () => {
  try {
    // Sammle alle einzigartigen CMMF-Codes (OHNE Wiederholung nach Menge)
    const cmmfList = positionen.value
      .filter(pos => pos.code_cmmf) // Nur Positionen mit CMMF
      .map(pos => pos.code_cmmf) // Nur den CMMF-Code, NICHT wiederholt
      .join('\n');

    if (!cmmfList) {
      toast.warning('Keine CMMF-Codes verfügbar');
      return;
    }

    // In Zwischenablage kopieren
    await navigator.clipboard.writeText(cmmfList);

    const anzahl = positionen.value.filter(pos => pos.code_cmmf).length;
    toast.success(`${anzahl} CMMF-Code${anzahl !== 1 ? 's' : ''} in Zwischenablage kopiert`);
  } catch (error) {
    console.error('Fehler beim Kopieren:', error);
    toast.error('Fehler beim Kopieren in Zwischenablage');
  }
};

const copyAnzahlToClipboard = async () => {
  try {
    // Sammle alle Mengen in derselben Reihenfolge wie CMMF
    const anzahlList = positionen.value
      .filter(pos => pos.code_cmmf) // Nur Positionen mit CMMF
      .map(pos => pos.menge) // Nur die Menge
      .join('\n');

    if (!anzahlList) {
      toast.warning('Keine Mengen verfügbar');
      return;
    }

    // In Zwischenablage kopieren
    await navigator.clipboard.writeText(anzahlList);

    const anzahl = positionen.value.filter(pos => pos.code_cmmf).length;
    toast.success(`${anzahl} Mengen in Zwischenablage kopiert`);
  } catch (error) {
    console.error('Fehler beim Kopieren:', error);
    toast.error('Fehler beim Kopieren in Zwischenablage');
  }
};

const saveLieferschein = async () => {
  loading.value.saving = true;
  try {
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'update_lieferschein',
        palette_id: selectedPalette.value.id,
        belegdatum: selectedPalette.value.belegdatum,
        lieferschein: selectedPalette.value.lieferschein,
        bestellnummer: selectedPalette.value.bestellnummer
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      toast.success('Lieferschein gespeichert');
    } else {
      toast.error(response.data.message || 'Fehler beim Speichern');
    }
  } catch (error) {
    console.error('Fehler:', error);
    toast.error('Netzwerkfehler');
  } finally {
    loading.value.saving = false;
  }
};

const freigabeAnVersand = async () => {
  // Prüfen ob ungespeicherte Änderungen vorliegen
  const hasChanges = originalPaletteData.value && (
    selectedPalette.value.belegdatum !== originalPaletteData.value.belegdatum ||
    selectedPalette.value.lieferschein !== originalPaletteData.value.lieferschein ||
    selectedPalette.value.bestellnummer !== originalPaletteData.value.bestellnummer
  );

  // Wenn Änderungen vorliegen, erst speichern
  if (hasChanges) {
    try {
      loading.value.saving = true;
      const saveResponse = await axios.post(
        `${API_BASE_URL}refurbish/index.php`,
        {
          action: 'update_lieferschein',
          palette_id: selectedPalette.value.id,
          belegdatum: selectedPalette.value.belegdatum,
          lieferschein: selectedPalette.value.lieferschein,
          bestellnummer: selectedPalette.value.bestellnummer
        },
        { withCredentials: true }
      );

      if (saveResponse.data.status !== 'success') {
        toast.error('Fehler beim Speichern der Änderungen');
        loading.value.saving = false;
        return;
      }

      // Original-Werte aktualisieren nach erfolgreichem Speichern
      originalPaletteData.value = {
        belegdatum: selectedPalette.value.belegdatum,
        lieferschein: selectedPalette.value.lieferschein,
        bestellnummer: selectedPalette.value.bestellnummer
      };

      toast.success('Änderungen gespeichert');
      loading.value.saving = false;
    } catch (error) {
      console.error('Fehler beim Speichern:', error);
      toast.error('Fehler beim Speichern der Änderungen');
      loading.value.saving = false;
      return;
    }
  }

  // Dann an Versand freigeben
  try {
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'update_palette_status',
        palette_id: selectedPalette.value.id,
        status: 'versand_final',
        office_notiz: selectedPalette.value.office_notiz
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      toast.success('An Versand freigegeben');
      backToList();
    } else {
      toast.error(response.data.message || 'Fehler');
    }
  } catch (error) {
    console.error('Fehler:', error);
    toast.error('Netzwerkfehler');
  }
};

const freigabeAnLager = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'update_palette_status',
        palette_id: selectedPalette.value.id,
        status: 'lager_final'
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      toast.success('An Lager freigegeben');
      backToList();
    } else {
      toast.error(response.data.message || 'Fehler');
    }
  } catch (error) {
    console.error('Fehler:', error);
    toast.error('Netzwerkfehler');
  }
};

const zurueckAnRefurbish = async () => {
  if (!confirm('Palette wirklich zurück an Refurbish senden?')) return;

  try {
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'update_palette_status',
        palette_id: selectedPalette.value.id,
        status: 'erfassung'
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      toast.success('Zurück an Refurbish gesendet');
      backToList();
    } else {
      toast.error(response.data.message || 'Fehler');
    }
  } catch (error) {
    console.error('Fehler:', error);
    toast.error('Netzwerkfehler');
  }
};

// ===== ARTIKEL-KATALOG =====

const fetchArtikelKatalog = async () => {
  loading.value.katalog = true;
  try {
    const response = await axios.get(`${API_BASE_URL}refurbish/index.php`, {
      params: { action: 'get_artikel_katalog' },
      withCredentials: true
    });

    if (response.data.status === 'success') {
      artikelKatalog.value = response.data.artikel || [];
    }
  } catch (error) {
    console.error('Fehler beim Laden des Katalogs:', error);
    toast.error('Fehler beim Laden des Artikel-Katalogs');
  } finally {
    loading.value.katalog = false;
  }
};

const gewichtNachtragen = (artikel) => {
  gewichtNachtragArtikel.value = artikel;
  neuesGewicht.value = null;
  dialogs.value.gewichtNachtragen = true;
};

const gewichtSpeichern = async () => {
  if (!neuesGewicht.value || neuesGewicht.value <= 0) {
    toast.error('Bitte gültiges Gewicht eingeben');
    return;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'update_artikel_gewicht',
        gtin_ean: gewichtNachtragArtikel.value.gtin_ean,
        gewicht_kg: parseFloat(neuesGewicht.value)
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      toast.success('Gewicht gespeichert');
      dialogs.value.gewichtNachtragen = false;

      // Position aktualisieren
      const pos = positionen.value.find(p => p.gtin_ean === gewichtNachtragArtikel.value.gtin_ean);
      if (pos) {
        pos.gewicht_kg = parseFloat(neuesGewicht.value);
      }

      // Palette neu laden
      await loadPalette(selectedPalette.value.id);
    } else {
      toast.error(response.data.message || 'Fehler beim Speichern');
    }
  } catch (error) {
    console.error('Fehler:', error);
    toast.error('Netzwerkfehler');
  }
};

const neuerArtikelDialog = () => {
  neuerArtikel.value = {
    gtin_ean: '',
    code_cmmf: '',
    description_cmmf: '',
    code_commercial: '',
    famille_n: '',
    family_lev1_description: '',
    eligible: '',
    gewicht_kg: null,
    paletten_nr: ''
  };
  dialogs.value.neuerArtikel = true;
};

const artikelSpeichern = async () => {
  if (!neuerArtikel.value.gtin_ean || !neuerArtikel.value.code_cmmf) {
    toast.error('EAN und Code CMMF sind Pflichtfelder');
    return;
  }

  try {
    loading.value.saving = true;
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'create_artikel',
        artikel: neuerArtikel.value
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      toast.success('Artikel erfolgreich erstellt');
      dialogs.value.neuerArtikel = false;
      await fetchArtikelKatalog();
    } else {
      toast.error(response.data.message || 'Fehler beim Erstellen');
    }
  } catch (error) {
    console.error('Fehler:', error);
    toast.error('Netzwerkfehler');
  } finally {
    loading.value.saving = false;
  }
};

const updateArtikelGewicht = async (artikel) => {
  if (!artikel.gewicht_kg || artikel.gewicht_kg <= 0) {
    toast.error('Bitte gültiges Gewicht eingeben');
    return;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}refurbish/index.php`,
      {
        action: 'update_artikel_gewicht',
        gtin_ean: artikel.gtin_ean,
        gewicht_kg: parseFloat(artikel.gewicht_kg)
      },
      { withCredentials: true }
    );

    if (response.data.status === 'success') {
      toast.success('Gewicht aktualisiert');
      await fetchArtikelKatalog();
    } else {
      toast.error(response.data.message || 'Fehler');
    }
  } catch (error) {
    console.error('Fehler:', error);
    toast.error('Netzwerkfehler');
  }
};

onMounted(() => {
  fetchPaletten();
});
</script>

<style scoped>
.office-container {
  padding: 20px;
}

.status-overview-card {
  background-color: rgba(30, 30, 35, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.card-divider {
  opacity: 0.1;
}

.form-field {
  margin-bottom: 12px;
}

.form-field :deep(.v-field__input) {
  color: rgba(255, 255, 255, 0.85);
}

.form-field :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12);
}

.form-field :deep(.v-field:hover .v-field__outline) {
  color: rgba(255, 255, 255, 0.18);
}

.dialog-card {
  background-color: rgba(30, 30, 35, 0.9);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
}

.sap-card,
.lieferschein-card {
  background: rgba(30, 30, 40, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.sap-table {
  background: rgba(50, 50, 60, 0.3);
  border-radius: 4px;
}

.lieferschein-preview {
  background: rgba(255, 255, 255, 0.02);
}

.artikel-tabelle {
  max-height: 300px;
  overflow-y: auto;
}

code {
  background: rgba(255, 255, 255, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.85rem;
}
</style>
